const removeModalBackdrop = () => {
  if (document.querySelectorAll(".modal-backdrop.fade.show").length) {
    document.querySelectorAll(".modal-backdrop.fade.show").forEach(item => {
      item.remove();
    });
  }
};

export { removeModalBackdrop };
